import { FetchType } from '@App/kit/components/WorkItemV2/fetch-type-enum'
import Navigation from '@App/navigation'

export const getSubmissionPath = (
    rightsholderId: number,
    workId: number | null | undefined,
    fetchType?: FetchType
): string =>
    workId
        ? fetchType === FetchType.MLC
            ? Navigation.rightholder.registrationHistory.submission(rightsholderId, workId)
            : Navigation.rightholder.registrationHistory.transaction(rightsholderId, workId)
        : ''
